/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { Box, Typography } from '@mui/material'
import React, { ReactNode } from 'react'

interface ICardTestimony {
    title: string
    children: ReactNode
}



export function CardTestimony(props: ICardTestimony) {
    

    /// Parte para colocar os stats e useEffects




    /// JSX
    return (
        <>
           <Box
                sx={{
                  height: { xs: 'auto', md: 640 },
                  bgcolor: '#1E1E1E',
                  padding: 3,
                  borderRadius: 2,
                  borderColor: '#323232',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: { xs: 'flex-start', md: 'space-between' },
                  position: 'relative'
                }}
            >
                <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography fontWeight={600} fontSize={'20px'} color='#FFFFFF'>
                      {props.title}
                  </Typography>
                  <Typography fontWeight={400} fontSize={'18px'} marginTop={2} lineHeight={1.6} component="div" sx={{
                    '& span': { fontSize: '18px', lineHeight: 1.6 }
                  }}>
                      {props.children}
                  </Typography>
                </Box>
                <Box
                    sx={{
                      mt: { xs: 4, md: 0 },
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: { xs: 'center', md: 'flex-end' },
                    }}
                >
                    <img width={80} height={80} src="/images/canada 2.png" />
                </Box>
            </Box>
        </>
    )

}